import * as React from "react";
import { TTranslate } from "../../../../service/locale/TranslationService";
import { TPublicationsReportApplicantPresentationModel } from "../../../../presenter/report/model/PublicationsReportApplicantPresentationModel";
import { Typography, Row, Col } from "antd";
import { TPublicationsReportReportingPeriodPresentationModel } from "../../../../presenter/report/model/PublicationsReportReportingPeriodPresentationModel";
import PublicationsReportReportingPeriod from "./PublicationsReportReportingPeriod";

const PublicationsReportApplicant = ({
  translate,
  applicant
}: {
  translate: TTranslate;
  applicant: TPublicationsReportApplicantPresentationModel;
}) => {
  const renderReportingPeriods = () => {
    let reportingPeriods: JSX.Element[] = [];
    applicant.reportingPeriods?.forEach(
      (
        reportingPeriod: TPublicationsReportReportingPeriodPresentationModel
      ) => {
        reportingPeriods.push(
          <PublicationsReportReportingPeriod
            key={`reporting-period-${reportingPeriod.reportingPeriodId}`}
            translate={translate}
            reportingPeriod={reportingPeriod}
          />
        );
      }
    );
    return reportingPeriods;
  };
  return (
    <div>
      <Typography.Title style={{ fontSize: 20, marginBottom: 10 }}>
        {`${translate("publications_report.applicant.fullname")}: ${
          applicant.fullname
        }`}
      </Typography.Title>

      <Row>
        <Col span={6}>
          <Typography.Paragraph>
            {`${translate("publications_report.applicant.father_name")}: ${
              applicant.fatherName
            }`}
          </Typography.Paragraph>
        </Col>
        <Col span={6}>
          <Typography.Paragraph>
            {`${translate("publications_report.applicant.maiden_name")}: ${
              applicant.maidenName
            }`}
          </Typography.Paragraph>
        </Col>
      </Row>
      {renderReportingPeriods()}
    </div>
  );
};
export default PublicationsReportApplicant;
